// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useBody } from "../Body/state/BodyContext";
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import axios from 'axios';
import CircularIndeterminate from "../Componentes/CircularIndeterminate";
import { ModalGeneral } from "../Componentes/ModalGeneral";
import { RUTA_API_RECIBOS } from "../Contantes/Constantes";
import KeyCloak from "../Auth/Keycloak";
import { PDFReader, MobilePDFReader } from 'reactjs-pdf-view';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import {DownloadIcono} from "./RecibosTable";
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {useAuth} from "../Auth/State/AuthContext";

export default function ModalVerRecibo ({downloadRecibos,recibo , open , onClose}) {
    const [base64 , setBase64] = useState(null);
    const [load , setLoad] = useState(true);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const {setMessage} = useBody();
    const {user,isLogedIn} = useAuth();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('lg'));

    const getBase64 = async () =>{
        await axiosInstance({
            method: 'GET',
            url: `${RUTA_API_RECIBOS}/${user.legajoPersonaUTN}/${recibo.name}/view`,
        })
            .then(response=>{
                setBase64(atob(response.data))
                setLoad(false);
            }).catch(error=>{
                setMessage("Hubo un error al traer el recibo (Codigo de error: 00032)")
        })
    }

    useEffect(() => {
        if(open && recibo) {
            setLoad(true);
            getBase64();
        }
    },[recibo])

    return <>
    <ModalGeneral
        open={open}
        onClose={onClose}
        titulo={"Vista previa de recibo"}
        Contenido= {
            <>
            {load ? 
            <CircularIndeterminate /> 
            :
                <>
                    <Divider/>
                    <br/>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div style={{float: 'right'}}>
                                <Tooltip title={"Descargar Recibo"}>
                                    <IconButton onClick={downloadRecibos} size="large">
                                        <DownloadIcono sx={{ fontSize: 40 }}/>
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ overflow: 'scroll'}}>
                                <PDFReader data={base64} width={matches ? 1300 : 1300}  />
                            </div>
                        </Grid>
                    </Grid>


                </>
            }
            </>
        }
    />
    </>;
}